/**
 * Created by r4zi4l on 27.01.2022
 */

const FieldInfoIcon = cc.Node.extend({
    ctor: function (action) {
        this._super();
        this.action = action;
        this.dragging = false;

        if (!action.locked) {
            this.adviceTarget = Map2d.SPAWN;
        }

        const styles = cleverapps.styles.FieldInfoIcon;

        const icon = this.createIcon();

        this.setContentSize2(styles.width, styles.height);
        this.setAnchorPoint(0.5, 0.5);
        this.setCascadeOpacityEnabled(true);
        this.setCascadeColorEnabled(true);

        icon.setAlignment(this.width / 2, this.height / 2);
        this.addChild(icon);

        if (action.locked) {
            this.setOpacity(120);
            this.setColor(new cc.Color(0, 150, 255, 255));
        } else {
            cleverapps.UI.onClick(this, this.onClick.bind(this, action.unit));

            cleverapps.UI.onDrag(this, {
                followPointer: true,
                onDragStart: this.onDragStart.bind(this),
                onDragMove: this.onDragMove.bind(this),
                onDragEnd: this.onDragEnd.bind(this)
            });

            cleverapps.UI.applyHover(this);
        }
    },

    createIcon: function () {
        const styles = cleverapps.styles.FieldInfoIcon;
        let icon;

        if (this.action.type === FieldInfoView.ACTION_HARVEST) {
            icon = new cc.Sprite(bundles.merge.frames.harvest_field);
        } else {
            icon = UnitView.getUnitImage(this.action.prize, {
                alignAnchorX: true,
                preferStatic: true
            });
        }

        cleverapps.UI.fitToBox(icon, {
            width: styles.width,
            height: styles.height,
            maxScale: 1.8
        });

        return icon;
    },

    createAdviceIcon: function () {
        const icon = this.createIcon();
        icon.setAlignment(this.width / 2, this.height / 2);
        this.addChild(icon);
        return icon;
    },

    onClick: function (unit) {
        for (let i = 0; i < unit.components.length; ++i) {
            const component = unit.components[i];
            if (component.canAcceptAction && component.canAcceptAction(this.action)) {
                component.acceptAction(this.action);
                break;
            }
        }
    },

    onDragStart: function () {
        if (this.dragging || Map2d.currentMap.dragging) {
            return false;
        }

        this.basePosition = this.getPosition();
        this.runAction(new cc.ScaleTo(0.2, 1.3));
        Map2d.currentMap.setDragging(this.action);
        cleverapps.userStatus.reportUserAction();
        this.dragging = true;
        return true;
    },

    onDragMove: function (touch) {
        if (this.dragging) {
            const unit = Map2d.currentMap.getMapView().findTouchUnit(touch);
            if (unit) {
                this.onClick(unit);
            }
        }
    },

    onDragEnd: function () {
        console.log("---onDragEnd", this.dragging);
        if (this.dragging) {
            this.setPosition(this.basePosition);

            this.dragging = false;

            if (Map2d.currentMap.dragging === this.action) {
                Map2d.currentMap.setDragging(undefined);
            }
        }

        this.basePosition = undefined;
    }
});

cleverapps.styles.FieldInfoIcon = {
    width: 60,
    height: 60
};
